import { render, staticRenderFns } from "./PortfolioList.vue?vue&type=template&id=0123901d&"
import script from "./PortfolioList.vue?vue&type=script&lang=ts&"
export * from "./PortfolioList.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports